import {Marker, Popup} from "react-map-gl";
import React, {Suspense, useEffect, useRef, useState} from "react";
import Announce from "../Map/Markers/Announce";
import VerticalHit from "../Hits/VerticalHit";
import {ScrollMenu} from "react-horizontal-scrolling-menu";
import 'react-horizontal-scrolling-menu/dist/styles.css'
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import usePreventBodyScroll from "../Hooks/usePreventBodyScroll";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/outline";
import classNames from "classnames";
import OutsideClickHandler from "react-outside-click-handler";

function Arrow({children, disabled, onClick, containerClasses}) {
    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={classNames('absolute top-16 bg-white text-blue-800 shadow-md flex items-center justify-center p-1 rounded-full z-10 hover:scale-125 transition-transform', containerClasses, {
                'hidden': disabled
            })}
        >
            {children}
        </button>
    );
}

function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);

    return (
        <Arrow disabled={isFirstItemVisible} onClick={() => scrollPrev()} containerClasses={'-left-6'}>
            <ChevronLeftIcon className={'w-6 h-6'} />
        </Arrow>
    );
}

function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

    return (
        <Arrow disabled={isLastItemVisible} onClick={() => scrollNext()} containerClasses={'-right-6'}>
            <ChevronRightIcon className={'w-6 h-6'} />
        </Arrow>
    );
}

const Cluster = ({ cluster, supercluster, props }) => {
    const { setViewport, setZoom, zoom } = props
    const { disableScroll, enableScroll } = usePreventBodyScroll();

    const {
        cluster: isCluster,
        point_count: pointCount,
        cluster_id
    } = cluster.properties;

    const [longitude, latitude] = cluster.geometry.coordinates;
    const [samePlaceHits, setSamePlaceHits] = useState()
    const [show, setShow] = useState(false)

    const onClick = ({cluster_id, longitude, latitude}) => {
        setViewport({
            longitude: parseFloat(longitude),
            latitude: parseFloat(latitude),
            zoom: zoom,
            fromCluster: true
        })

        setSamePlaceHits(supercluster.getLeaves(cluster_id, 100))
    }

    const handleOutsideClick = () => {
        setShow(false)
    }

    useEffect(() => {
        if (samePlaceHits) {
            setShow(true)
        }
    }, [samePlaceHits])

    return (
        isCluster ?
            <>
                {
                    show ?
                        <Popup
                            longitude={longitude}
                            latitude={latitude}
                            closeButton={false}
                            closeOnClick={false}
                            focusAfterOpen={false}
                            maxWidth={'18rem'}
                            offset={12}
                        >
                                <div
                                    onMouseEnter={disableScroll}
                                    onMouseLeave={enableScroll}
                                    className={'relative'}
                                >
                                    <OutsideClickHandler onOutsideClick={handleOutsideClick}>
                                        <ScrollMenu
                                            LeftArrow={LeftArrow}
                                            RightArrow={RightArrow}
                                            options={{
                                                ratio: .75,
                                                rootMargin: "0px"
                                            }}
                                            // transitionDuration={750}
                                            wrapperClassName={'w-64'}
                                            scrollContainerClassName={'overflow-hidden'}
                                        >
                                            {
                                                samePlaceHits.map(({ properties }) => (
                                                    <VerticalHit
                                                        key={'announce-' + properties.id}
                                                        hit={properties}
                                                        props={{ class: 'inline-block w-64' }}
                                                        itemId={properties.id}
                                                    />
                                                ))
                                            }
                                        </ScrollMenu>
                                    </OutsideClickHandler>
                                </div>
                        </Popup>
                        : null
                }

                <Marker
                    latitude={latitude}
                    longitude={longitude}
                    onClick={() => onClick({cluster_id, longitude, latitude})}
                >
                    <div
                        className="flex items-center justify-center text-white rounded-full p-2 bg-gradient-to-r from-blue-800 to-blue-500 hover:ring-4 transition"
                        style={{
                            width: `${30 + (pointCount * 2)}px`,
                            height: `${30 + (pointCount * 2)}px`
                        }}
                    >
                        {pointCount}
                    </div>
                </Marker>
            </> :
            <Announce hit={cluster.properties} />
    )
}

export default Cluster